export default {
  scenes: {
    comfortOfRoutine: {
      beats: {
        missedMorning: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliCafe'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'surprised',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'surprised',
              text: "For the first time in weeks, Reina shows up at the café—and Eric isn't there. The realization catches her off guard.",
              choices: [
                {
                  text: "Brush It Off",
                  next: {
                    scene: 'comfortOfRoutine',
                    beat: 'brushItOff'
                  }
                },
                {
                  text: "Text Him Casually",
                  next: {
                    scene: 'comfortOfRoutine',
                    beat: 'textHimCasually'
                  }
                }
              ]
            }
          ]
        },
        brushItOff: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "Guess I got used to something I shouldn't have."
            },
            {
              type: 'showCharacter',
              characterId: 'barista',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'barista',
              variation: 'happy',
              text: "Your usual? Or are you waiting for someone?"
            },
            {
              type: 'hideCharacter',
              characterId: 'barista',
              position: 'center'
            }
          ],
          next: {
            scene: 'comfortOfRoutine',
            beat: 'suddenChange'
          }
        },
        textHimCasually: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "You ditching our unspoken coffee meetings now?"
            },
            {
              type: 'showNarration',
              text: "Eric: Running late. No big deal."
            }
          ],
          next: {
            scene: 'comfortOfRoutine',
            beat: 'suddenChange'
          }
        },
        suddenChange: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: "What, did I finally scare you away?"
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: "Not that easy to get rid of me."
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'center'
            }
          ],
          next: {
            scene: 'conversationsDontLand',
            beat: 'groupDiscussion'
          }
        }
      }
    },
    conversationsDontLand: {
      beats: {
        groupDiscussion: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliCafe'
            },
            {
              type: 'showNarration',
              text: "During a team lunch, the usual banter feels… different. Reina catches herself waiting for Eric's usual remarks, but they don't come."
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "During a team lunch, the usual banter feels… different. Reina catches herself waiting for Eric's usual remarks, but they don't come.",
              choices: [
                {
                  text: "Casually Call Him Out",
                  next: {
                    scene: 'conversationsDontLand',
                    beat: 'casuallyCallOut'
                  }
                },
                {
                  text: "Let It Slide",
                  next: {
                    scene: 'conversationsDontLand',
                    beat: 'letItSlide'
                  }
                }
              ]
            }
          ]
        },
        casuallyCallOut: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: "You're quiet today. Did the caffeine finally wear off?"
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: "Just a lot on my mind. No big deal."
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'center'
            }
          ],
          next: {
            scene: 'conversationsDontLand',
            beat: 'hollowReassurance'
          }
        },
        letItSlide: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: "Well, guess someone else has to carry the conversation today."
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: "I believe in you."
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'center'
            }
          ],
          next: {
            scene: 'conversationsDontLand',
            beat: 'hollowReassurance'
          }
        },
        hollowReassurance: {
          events: [
            {
              type: 'showNarration',
              text: "Eric still responds, still shows up, but something is missing. It's subtle, but Reina knows something has shifted."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: "Maybe I'm imagining it."
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showNarration',
              text: "Eric avoids her gaze."
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'center'
            }
          ],
          next: {
            scene: 'firstRealDistance',
            beat: 'canceledPlan'
          }
        }
      }
    },
    firstRealDistance: {
      beats: {
        canceledPlan: {
          events: [
            {
              type: 'showLocation',
              locationId: 'cityStreet'
            },
            {
              type: 'showNarration',
              text: "For the first time, Eric backs out of a planned outing at the last minute. Reina finds herself standing at the meeting point, alone."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'sad',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: "For the first time, Eric backs out of a planned outing at the last minute. Reina finds herself standing at the meeting point, alone.",
              choices: [
                {
                  text: "Text Him Directly",
                  next: {
                    scene: 'firstRealDistance',
                    beat: 'textHimDirectly'
                  }
                },
                {
                  text: "Act Like It's No Big Deal",
                  next: {
                    scene: 'firstRealDistance',
                    beat: 'actLikeNoBigDeal'
                  }
                }
              ]
            }
          ]
        },
        textHimDirectly: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "Everything okay?"
            },
            {
              type: 'showNarration',
              text: "Eric: Yeah. Just swamped. Rain check?"
            }
          ],
          next: {
            scene: 'firstRealDistance',
            beat: 'somethingLeftUnsaid'
          }
        },
        actLikeNoBigDeal: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "It's not like we planned anything serious."
            },
            {
              type: 'showNarration',
              text: "She walks off, pretending it doesn't bother her."
            }
          ],
          next: {
            scene: 'firstRealDistance',
            beat: 'somethingLeftUnsaid'
          }
        },
        somethingLeftUnsaid: {
          events: [
            {
              type: 'showNarration',
              text: "Even though it's small, it lingers. For the first time, Reina feels like she doesn't know what to expect from him anymore."
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: "…Maybe I made this into something bigger than it was."
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'center'
            }
          ],
          next: {
            scene: 'riverbank',
            beat: 'sittingWithDoubt'
          }
        }
      }
    },
    riverbank: {
      beats: {
        sittingWithDoubt: {
          events: [
            {
              type: 'showLocation',
              locationId: 'riverbank'
            },
            {
              type: 'showNarration',
              text: "Instead of going straight home, Reina finds herself at the quiet bench by the river, watching boats pass by. It's a familiar place now—a space she and Eric used to sit and talk. But tonight, she's alone."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'sad',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: "Instead of going straight home, Reina finds herself at the quiet bench by the river, watching boats pass by. It's a familiar place now—a space she and Eric used to sit and talk. But tonight, she's alone.",
              choices: [
                {
                  text: "Let the Doubt Sink In",
                  next: {
                    scene: 'riverbank',
                    beat: 'letDoubtSinkIn'
                  }
                },
                {
                  text: "Send a Message",
                  next: {
                    scene: 'riverbank',
                    beat: 'sendMessage'
                  }
                }
              ]
            }
          ]
        },
        letDoubtSinkIn: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: "Maybe we were just work friends all along. And now it's ending."
            },
            {
              type: 'showNarration',
              text: "The river flows on, indifferent to her thoughts."
            }
          ],
          next: {
            scene: 'riverbank',
            beat: 'momentOfRealization'
          }
        },
        sendMessage: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: "I miss our late-night conversations."
            },
            {
              type: 'showNarration',
              text: "Eric: (seen, no reply)."
            },
            {
              type: 'showNarration',
              text: "Reina locks her phone, staring at the water."
            }
          ],
          next: {
            scene: 'riverbank',
            beat: 'momentOfRealization'
          }
        },
        momentOfRealization: {
          events: [
            {
              type: 'showNarration',
              text: "No matter what she chooses, the feeling is the same: something is slipping through her fingers, and she doesn't know how to hold onto it."
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: "I don't like this feeling."
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'center'
            }
          ],
          goToChapter: {
            chapter: 'chapter5'
          }
        }
      }
    }
  }
}
